import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import _ from 'lodash';
import dateFormat from 'dateformat';

import Post from "./Post";
import FormPost from "./forms/FormPost";
import PostListFilter from "./PostListFilter";

//import post from "../forms/setup/post"

@inject('postStore')
@inject('postForm')
@inject('postMessageForm')
@observer
export default class PostList extends Component {

    render() {
        let { isLoggedIn } = this.props;
        var postForm = this.props.postForm;
        var postList = _(this.props.postStore.posts).groupBy(item => dateFormat(item.lastchangeddatetime, "mmm dd, yyyy")).map(function (value, key) {

            return <div className="post-sublist" key={key}><div className="post-sublist-date">{key}</div>
                <div className="post-sublist-list">
                    {value.map(post => (<Post post={post} key={post.id} postForm={postForm} isLoggedIn={isLoggedIn} />))}
                </div></div>;
        }).value();

        return (
            <div className="postlistcontainer">
                <div className="postlist-header"><span className="spanNews">{this.props.postForm.display && isLoggedIn ? 'Add New Update' : 'Updates'}</span>
                    {!this.props.postForm.display && isLoggedIn &&
                        <button
                            type="button"
                            onClick={() => {
                                this.props.postForm.show();
                            }}
                            className="add-new-post"
                            text={"Add New"}><span>+</span>Add New</button>}
                </div>
                {isLoggedIn && <FormPost form={this.props.postForm} />}
                {postList}
                <PostListFilter />
            </div >
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/PostList.jsx